import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.space.Organization.Filter,
  graphql.schema.OrganizationsFilterInput
>({
  includeInaccessible: transformers.PASS_THROUGH,
  jointUseCalcMode: graphql.transformers.IN.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Organization.JointUseCalculationMode
      .isJointUseCalculationMode,
  ),
  parentIds: graphql.transformers.IN.list(
    graphql.transformers.IN.validate(
      transformers.PASS_THROUGH,
      ents.extra.space.Organization.Id.isId,
    ),
  ),
})
